import {
  createFrontendPlugin,
  createRouteRef,
  type OverridableFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon, iconRepair } from '@ns/plugin-ns-theme';
import { isToolEntity } from '@ns/plugin-ns-tools-catalog-common';

const toolExplorerRouteRef = createRouteRef();

const toolExplorerPage = PageBlueprint.make({
  name: 'index',
  params: {
    icon: <Icon glyph={iconRepair} />,
    loader: () =>
      import('./components/tool-explorer-page/tool-explorer-page').then(m => (
        <m.ToolExplorerPage />
      )),
    path: '/tools',
    routeRef: toolExplorerRouteRef,
    title: 'Software',
  },
});

const toolAboutCard = EntityCardBlueprint.make({
  name: 'about',
  params: {
    filter: isToolEntity,
    loader: () =>
      import('./components/tool-about-card/tool-about-card').then(m => (
        <m.ToolAboutCard />
      )),
  },
});

const toolSupportCard = EntityCardBlueprint.make({
  name: 'support',
  params: {
    filter: isToolEntity,

    loader: () =>
      import('./components/tool-support-card/tool-support-card').then(m => (
        <m.ToolSupportCard />
      )),
    // Render in the right-hand info column of DefaultEntityContentLayout.
    type: 'info',
  },
});

const nsToolsCatalogPlugin: OverridableFrontendPlugin = createFrontendPlugin({
  extensions: [toolExplorerPage, toolAboutCard, toolSupportCard],
  pluginId: 'ns-tools-catalog',
  routes: { root: toolExplorerRouteRef },
});

export default nsToolsCatalogPlugin;

// Page Components
export { ToolDetailPage } from './components/tool-detail-page/tool-detail-page';
export { ToolExplorerPage } from './components/tool-explorer-page/tool-explorer-page';

// Entity Cards
export { ToolAboutCard } from './components/tool-about-card/tool-about-card';
export type { ToolAboutCardContentProps } from './components/tool-about-card/tool-about-card-content';
export { ToolAboutCardContent } from './components/tool-about-card/tool-about-card-content';
export { ToolSupportCard } from './components/tool-support-card/tool-support-card';
export type { ToolSupportCardContentProps } from './components/tool-support-card/tool-support-card-content';
export { ToolSupportCardContent } from './components/tool-support-card/tool-support-card-content';

// Filters
export { EntityCapabilityFilter } from './filters/entity-capability-filter';
export { EntityRecommendedStateFilter } from './filters/entity-recommended-state-filter';
export { EntityTechStackFilter } from './filters/entity-tech-stack-filter';

// Pickers
export type { CapabilityFilters } from './pickers/capability-picker';
export { CapabilityPicker } from './pickers/capability-picker';
export type { RecommendedStateFilters } from './pickers/recommended-state-picker';
export { RecommendedStatePicker } from './pickers/recommended-state-picker';
export type { TechStackFilters } from './pickers/tech-stack-picker';
export { TechStackPicker } from './pickers/tech-stack-picker';

// Columns
export { toolColumns } from './columns/tool-columns';
